import React, { useEffect, useRef, useState } from 'react';
import { ChromePicker } from 'react-color';
import { Box, ClickAwayListener } from '@mui/material';

interface Props {
  initialColor?: string;
  onColorChanged?: (value: string) => void;
}

export const ColorPickerField = ({ initialColor, onColorChanged }: Props) => {
  const [isColorPickerVisible, setIsColorPickerVisible] = useState(false);
  const [value, setValue] = useState<string>(initialColor ?? '#E89623');
  const anchorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (initialColor) setValue(initialColor);
  }, [initialColor]);

  return (
    <>
      <Box
        ref={anchorRef}
        onClick={() => setIsColorPickerVisible(true)}
        sx={{
          boxShadow: 1,
          cursor: 'pointer',
          minWidth: '1.75rem',
          borderRadius: '50%',
          minHeight: '1.75rem',
          backgroundColor: value,
          border: '1px solid #ccc',
        }}
      />

      {isColorPickerVisible && (
        <ClickAwayListener onClickAway={() => setIsColorPickerVisible(false)}>
          <Box
            sx={{ position: 'absolute', zIndex: 1300, mt: 1 }}
            style={{
              top: anchorRef.current?.getBoundingClientRect().bottom ?? 0,
              left: anchorRef.current?.getBoundingClientRect().left ?? 0,
              position: 'fixed',
            }}
          >
            <ChromePicker
              color={value}
              onChange={color => {
                setValue(color.hex);
                onColorChanged?.(color.hex);
              }}
            />
          </Box>
        </ClickAwayListener>
      )}
    </>
  );
};
